import { UserState } from "../models/UserState";

const disabledError = (state: UserState) => {
    state.isError = null;
}

export default disabledError;